import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton, Menu, MenuItem } from '@mui/material';
import React, { useState } from 'react';
import {
  Confirm,
  EditButton,
  useDelete,
  useRecordContext,
  useRedirect,
} from 'react-admin';

export const ActionMenu = ({ resource }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteOne, { isLoading }] = useDelete();
  const record = useRecordContext();
  const redirect = useRedirect();

  const handleMenuOpen = event => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleCancel = () => {
    setConfirmOpen(false);
  };

  const handleDeleteClick = () => {
    setConfirmOpen(true);
    handleMenuClose();
  };

  const handleConfirm = () => {
    deleteOne(resource, { id: record.id });
    setConfirmOpen(false);
  };

  return (
    <>
      <IconButton onClick={handleMenuOpen}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        sx={{ backgroundColor: 'rgba(0, 0, 0, 0.04)' }}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        onClick={event => event.stopPropagation()}
      >
        <MenuItem
          onClick={() => {
            resource == 'members' && redirect(`/${resource}/${record.id}`);
            setAnchorEl(null);
          }}
        >
          <EditButton
            sx={{
              color: 'unset',
              padding: '0',
              fontSize: '16px',
              textTransform: 'none',
              justifyContent: 'flex-start !important',
              fontWeight: '400 !important',
              '&.RaEditButton-root:hover': {
                backgroundColor: 'unset',
              },
            }}
            icon={null}
            record={record}
            onClick={() => {
              setAnchorEl(null);
            }}
          />
        </MenuItem>
        <MenuItem onClick={handleDeleteClick}>Eliminar</MenuItem>
      </Menu>
      <Confirm
        isOpen={confirmOpen}
        loading={isLoading}
        title="¿Esta seguro que desea eliminarlo?"
        content="No podra revertir esta accion."
        onConfirm={handleConfirm}
        onClose={handleCancel}
      />
    </>
  );
};
